<div id="map-popup"
     class="map-popup-hotel js-show-hotel-info-data showHotelInfoData"
     [attr.data-id]="tour.id"
     [attr.data-hotel-id]="tour.hotelId">

    <div class="map-popup-hotel__photo"
         [style.background-image]="photo">
        <div *ngIf="tour.rating && tour.rating > 0"
             class="map-popup-hotel__booking">
            <div class="map-popup-hotel__booking-info">
                <div class="map-popup-hotel__booking-logo">
                    <img class="booking-logo" src="/x-assets/img/logo/logo-booking.svg">
                </div>
                <div *ngIf="tour.bookingReviewsCount && tour.bookingReviewsCount > 0"
                     class="map-popup-hotel__booking-reviews">{{ tour.bookingReviewsCount }} отзывов</div>
            </div>
            <div class="map-popup-hotel__rating">{{ bookingRating }}</div>
        </div>
    </div>

    <div class="map-popup-hotel__content">
        <div class="map-popup-hotel__stars">
            <app-hotel-stars [value]="tour.stars || tour.hotelClass"></app-hotel-stars>
        </div>

        <div class="map-popup-hotel__title">{{ hotelTitle }}</div>

        <div class="map-popup-hotel__services">
            <app-hotel-services [tour]="tour"></app-hotel-services>
        </div>

        <div class="map-popup-hotel__footer">
            <div class="map-popup-hotel__price-col">
                <div class="map-popup-hotel__tourists">{{ touristsText }}</div>
                <div class="map-popup-hotel__price">{{ tour.price.value | priceFormat:tour.price.currency }}</div>
            </div>

            <button type="button"
                    class="map-popup-hotel__button btn-clear showHotelInfo"
                    (click)="openTour()">{{ messages.viewTour }}</button>
        </div>
    </div>
</div>

